var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 615.034,
    height: 413.835,
    viewBox: "0 0 615.034 413.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mission",
    transform: "translate(-41.785 -38.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5741",
    "data-name": "Group 5741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5703",
    "data-name": "Group 5703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5681",
    "data-name": "Group 5681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5680",
    "data-name": "Group 5680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4699",
    "data-name": "Path 4699",
    d: "M199.031,192.3s-5.6-4.583-14.382,9.024-12.407,21.6-12.407,21.6-2.242,2.81-4.106.633-4.124-8.045-7.739-7.4c-3.749.669-5.365,4.611-5.282,10.656s-.221,19.293-.253,20.491c-.031,1.176-.876,2.827-2.384,1.547s-9.776-12.628-14.926-8.383-2.152,21.047-1.859,22.89-.137,2.573-1.035,2.93-3.317-3.72-5.8-6.851-5.912-6.327-8.679-3.628-4.808,14.865,4.811,35.951l5.1,9.479,10.8.5c23.175-.331,33.3-7.383,34.552-11.038s-3.1-5.386-6.993-6.291-8.613-1.347-8.675-2.311.415-1.665,2.206-2.189,18.258-5.005,19.891-11.476-12.162-9.088-13.964-9.9-.671-2.285.378-2.816c1.069-.542,12.914-6.487,18.412-9s8.37-5.659,7.37-9.333c-.965-3.544-7.234-3.074-10-3.828s-1.186-3.982-1.186-3.982,5.677-6.693,14.215-20.458,1.821-16.9,1.821-16.9",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5684",
    "data-name": "Group 5684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5683",
    "data-name": "Group 5683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5682",
    "data-name": "Group 5682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4700",
    "data-name": "Path 4700",
    d: "M128.176,302.991c6.31-10.084,17.827-27.819,27.635-43.1s18.669-29.107,25.029-39.159l7.521-11.911,2.047-3.237.539-.838c.124-.187.194-.279.194-.279s-.051.1-.165.3l-.511.855-1.994,3.27c-1.735,2.839-4.274,6.928-7.431,11.969-6.31,10.084-15.143,23.94-24.948,39.213s-21.355,32.99-27.716,43.041",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5687",
    "data-name": "Group 5687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5686",
    "data-name": "Group 5686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5685",
    "data-name": "Group 5685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4701",
    "data-name": "Path 4701",
    d: "M163.226,224.492a3.453,3.453,0,0,1,.2.754c.107.489.24,1.2.4,2.081.309,1.761.675,4.205,1.03,6.909.34,2.667.648,5.079.883,6.924.111.831.205,1.532.28,2.1a3.554,3.554,0,0,1,.074.775,3.434,3.434,0,0,1-.2-.753c-.1-.489-.239-1.2-.386-2.083-.292-1.765-.626-4.212-.98-6.916-.36-2.663-.684-5.072-.933-6.915-.115-.831-.213-1.532-.291-2.1A3.571,3.571,0,0,1,163.226,224.492Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5690",
    "data-name": "Group 5690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5689",
    "data-name": "Group 5689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5688",
    "data-name": "Group 5688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4702",
    "data-name": "Path 4702",
    d: "M167.049,244.322c-.016-.091,4.989-1.067,11.177-2.179s11.221-1.942,11.237-1.851-4.987,1.067-11.178,2.18S167.066,244.413,167.049,244.322Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5693",
    "data-name": "Group 5693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5692",
    "data-name": "Group 5692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5691",
    "data-name": "Group 5691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4703",
    "data-name": "Path 4703",
    d: "M150.932,267.1a3.761,3.761,0,0,1,.794.045l2.148.228c1.813.189,4.318.44,7.092.615s5.292.26,7.115.3l2.159.051a3.667,3.667,0,0,1,.793.057,3.637,3.637,0,0,1-.792.073c-.51.025-1.249.047-2.162.055-1.826.019-4.351-.021-7.134-.2s-5.291-.465-7.1-.715c-.9-.129-1.635-.241-2.137-.333A3.593,3.593,0,0,1,150.932,267.1Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5696",
    "data-name": "Group 5696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5695",
    "data-name": "Group 5695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5694",
    "data-name": "Group 5694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4704",
    "data-name": "Path 4704",
    d: "M143.527,249.925a3.1,3.1,0,0,1,.358.642q.351.735.862,1.8c.715,1.527,1.681,3.646,2.729,5.994s1.982,4.484,2.641,6.035q.453,1.09.766,1.845a3.042,3.042,0,0,1,.238.7,3.145,3.145,0,0,1-.357-.642l-.863-1.8c-.714-1.527-1.681-3.646-2.73-6s-1.981-4.482-2.64-6.034c-.3-.726-.557-1.343-.765-1.844A3.124,3.124,0,0,1,143.527,249.925Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5699",
    "data-name": "Group 5699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5698",
    "data-name": "Group 5698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5697",
    "data-name": "Group 5697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4705",
    "data-name": "Path 4705",
    d: "M126.743,268.226a5.068,5.068,0,0,1,.45.825l1.114,2.3c.927,1.952,2.187,4.657,3.559,7.654s2.6,5.72,3.471,7.7c.41.948.752,1.737,1.017,2.349a5.083,5.083,0,0,1,.331.879,4.974,4.974,0,0,1-.449-.825c-.29-.6-.664-1.375-1.114-2.3-.927-1.952-2.187-4.658-3.56-7.656s-2.6-5.719-3.47-7.7l-1.017-2.348A5.073,5.073,0,0,1,126.743,268.226Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5702",
    "data-name": "Group 5702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5701",
    "data-name": "Group 5701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5700",
    "data-name": "Group 5700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4706",
    "data-name": "Path 4706",
    d: "M136.594,289.35a5.772,5.772,0,0,1,1.007.031l2.733.19c2.308.158,5.5.364,9.023.492s6.722.17,9.035.18l2.74.014a5.759,5.759,0,0,1,1.006.044,5.855,5.855,0,0,1-1,.086c-.647.035-1.583.069-2.741.092-2.315.05-5.517.051-9.05-.082s-6.724-.372-9.029-.591c-1.153-.112-2.084-.212-2.727-.3A6.039,6.039,0,0,1,136.594,289.35Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5710",
    "data-name": "Group 5710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5708",
    "data-name": "Group 5708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5705",
    "data-name": "Group 5705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5704",
    "data-name": "Group 5704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4707",
    "data-name": "Path 4707",
    d: "M110.914,230.438a28.788,28.788,0,0,1-.279,4.93,35.853,35.853,0,0,1-4.5,13.232l-.1-.181h.217l-.1.182L78.141,298.273l-.176.311-.19-.3L48.166,251.049l-1.456-2.325-.226-.361.426,0h0l-.2.353a36.3,36.3,0,0,1-4.462-12.477,34.544,34.544,0,0,1-.444-6.492q.089-1.612.175-3.213.24-1.585.477-3.156a36.415,36.415,0,0,1,12.087-20.667,35.026,35.026,0,0,1,9.741-5.725l1.288-.48.641-.239.657-.175,2.61-.68a36.4,36.4,0,0,1,5.219-.633,35.1,35.1,0,0,1,5.076.091c.828.066,1.637.245,2.444.36l1.2.194c.4.083.779.2,1.167.3l2.292.621,2.173.828c.356.141.718.264,1.064.418l1.011.506,1.982,1a35.9,35.9,0,0,1,11.5,10.617,36.553,36.553,0,0,1,5.011,10.722,32.457,32.457,0,0,1,.883,4.236,23.425,23.425,0,0,1,.335,3.15q.044,1.268.067,1.947c.013.438.007.662.007.662s-.026-.224-.054-.662-.064-1.1-.114-1.941a24.171,24.171,0,0,0-.378-3.135,32.95,32.95,0,0,0-.92-4.208,36.654,36.654,0,0,0-5.051-10.623,35.727,35.727,0,0,0-11.45-10.479L90.98,198.4l-1-.5c-.343-.151-.7-.271-1.055-.409l-2.152-.814-2.271-.606c-.383-.1-.764-.215-1.155-.3l-1.19-.188c-.8-.111-1.6-.286-2.418-.349a34.635,34.635,0,0,0-5.02-.077,36.113,36.113,0,0,0-5.157.637l-2.577.678-.649.174-.632.237-1.272.477a34.682,34.682,0,0,0-9.612,5.672A36.018,36.018,0,0,0,42.9,223.467q-.232,1.551-.468,3.116-.085,1.581-.171,3.174a34.1,34.1,0,0,0,.442,6.41,35.856,35.856,0,0,0,4.407,12.314l.207.354h-.412l.2-.359,1.456,2.324,29.572,47.256-.366.008,28.17-49.583.1.18h-.219l.106-.182a36.228,36.228,0,0,0,4.576-13.128c.23-1.594.3-2.827.349-3.655.015-.405.026-.715.035-.939S110.914,230.438,110.914,230.438Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5707",
    "data-name": "Group 5707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5706",
    "data-name": "Group 5706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4708",
    "data-name": "Path 4708",
    d: "M98.349,230.043a2.012,2.012,0,0,1-.041-.354c-.018-.257-.043-.6-.073-1.038-.015-.231-.031-.485-.048-.764s-.091-.583-.141-.913a15.98,15.98,0,0,0-.457-2.255,20.9,20.9,0,0,0-2.419-5.794,21.7,21.7,0,0,0-26.038-9.309,19.848,19.848,0,0,0-5.488,2.938,19.828,19.828,0,0,0-4.59,4.588,21,21,0,0,0-3.11,5.959,21.473,21.473,0,0,0-.036,13.665,20.98,20.98,0,0,0,3.08,5.976,19.777,19.777,0,0,0,4.567,4.614,19.9,19.9,0,0,0,5.474,2.966,21.754,21.754,0,0,0,26.086-9.179,20.9,20.9,0,0,0,2.447-5.781,16.014,16.014,0,0,0,.469-2.252c.051-.33.113-.633.145-.912l.052-.764c.033-.437.059-.781.078-1.037a1.977,1.977,0,0,1,.043-.354,2.073,2.073,0,0,1,0,.355c-.008.257-.019.6-.032,1.042l-.029.77c-.025.281-.08.587-.124.92a15.556,15.556,0,0,1-.43,2.277,20.7,20.7,0,0,1-2.4,5.871,22.027,22.027,0,0,1-14.857,10.41,22.111,22.111,0,0,1-11.6-.96,20.325,20.325,0,0,1-5.593-3.012,20.234,20.234,0,0,1-4.671-4.7,21.409,21.409,0,0,1-3.152-6.1,21.9,21.9,0,0,1,.037-13.961,21.4,21.4,0,0,1,3.183-6.083,20.234,20.234,0,0,1,4.693-4.677,20.328,20.328,0,0,1,5.608-2.983,22.113,22.113,0,0,1,11.607-.9,22.037,22.037,0,0,1,14.8,10.484,20.735,20.735,0,0,1,2.37,5.884,15.422,15.422,0,0,1,.418,2.28c.043.333.1.638.119.92s.018.538.026.77c.011.44.02.785.027,1.043A2.032,2.032,0,0,1,98.349,230.043Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5709",
    "data-name": "Group 5709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4709",
    "data-name": "Path 4709",
    d: "M76.027,240.232,63.3,231.355l3.1-4.439,8.531,5.952L85.97,218.845l4.254,3.348Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5718",
    "data-name": "Group 5718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5717",
    "data-name": "Group 5717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5716",
    "data-name": "Group 5716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5715",
    "data-name": "Group 5715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5714",
    "data-name": "Group 5714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5713",
    "data-name": "Group 5713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5712",
    "data-name": "Group 5712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5711",
    "data-name": "Group 5711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4710",
    "data-name": "Path 4710",
    d: "M432.085,75.867a42.124,42.124,0,0,1,10.821,2.858l7.954-6.666,13.662,10.4-4.3,9.443a42.046,42.046,0,0,1,5.639,9.67l10.334.91L478.5,119.5l-9.716,3.632a41.959,41.959,0,0,1-2.86,10.823l6.666,7.954-10.4,13.662-9.443-4.3a42.089,42.089,0,0,1-9.672,5.637l-.908,10.334-17.016,2.31-3.631-9.718a41.99,41.99,0,0,1-10.822-2.859l-7.956,6.667-13.663-10.4,4.307-9.444a42.135,42.135,0,0,1-5.639-9.669l-10.332-.911L375.107,116.2l9.717-3.631a41.964,41.964,0,0,1,2.859-10.824l-6.667-7.954,10.4-13.662,9.444,4.305a42.05,42.05,0,0,1,9.671-5.638l.91-10.333,17.013-2.309,3.634,9.717Zm-5.1,23.462a18.422,18.422,0,1,0,18.5,14.09A18.427,18.427,0,0,0,426.982,99.329Z",
    fill: "#f5f5f5",
    fillRule: "evenodd"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5726",
    "data-name": "Group 5726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5725",
    "data-name": "Group 5725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5724",
    "data-name": "Group 5724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5723",
    "data-name": "Group 5723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5722",
    "data-name": "Group 5722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5721",
    "data-name": "Group 5721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5720",
    "data-name": "Group 5720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5719",
    "data-name": "Group 5719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4711",
    "data-name": "Path 4711",
    d: "M277.146,130.264a27.332,27.332,0,0,1,7.025,1.855l5.163-4.327,8.869,6.75-2.794,6.13a27.332,27.332,0,0,1,3.66,6.277l6.709.591,1.5,11.044-6.307,2.358a27.243,27.243,0,0,1-1.856,7.025l4.327,5.164L296.69,182l-6.13-2.794a27.36,27.36,0,0,1-6.278,3.66l-.59,6.708-11.046,1.5-2.357-6.308a27.254,27.254,0,0,1-7.025-1.856l-5.164,4.328-8.869-6.751,2.795-6.13a27.383,27.383,0,0,1-3.66-6.276l-6.707-.592-1.5-11.044,6.308-2.357a27.21,27.21,0,0,1,1.856-7.026L244,141.9l6.749-8.868,6.131,2.795a27.313,27.313,0,0,1,6.277-3.661l.591-6.707,11.044-1.5,2.358,6.307Zm-3.312,15.23a11.958,11.958,0,1,0,12.01,9.146A11.961,11.961,0,0,0,273.834,145.494Z",
    fill: "#ebebeb",
    fillRule: "evenodd"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5737",
    "data-name": "Group 5737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5731",
    "data-name": "Group 5731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5730",
    "data-name": "Group 5730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5729",
    "data-name": "Group 5729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5728",
    "data-name": "Group 5728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5727",
    "data-name": "Group 5727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4712",
    "data-name": "Path 4712",
    d: "M369.817,210.99a14.6,14.6,0,0,1,3.993,2.64A19.233,19.233,0,0,1,380,225.008a19.476,19.476,0,0,1-.684,9.067,19.774,19.774,0,0,1-5.709,8.737,19.785,19.785,0,0,1-10.481,4.791,19.711,19.711,0,0,1-20.589-11.293,19.789,19.789,0,0,1-1.593-11.415,19.784,19.784,0,0,1,4.3-9.512,19.486,19.486,0,0,1,7.279-5.448,19.238,19.238,0,0,1,12.921-.893,14.607,14.607,0,0,1,4.372,1.948c-.057.125-1.529-.791-4.48-1.53a19.259,19.259,0,0,0-12.495,1.192,18.875,18.875,0,0,0-10.888,14.4,18.874,18.874,0,0,0,1.568,10.8,18.719,18.719,0,0,0,19.461,10.675,18.878,18.878,0,0,0,9.949-4.482,18.878,18.878,0,0,0,6.293-16.919,19.255,19.255,0,0,0-5.709-11.179C371.307,211.855,369.743,211.106,369.817,210.99Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5736",
    "data-name": "Group 5736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5735",
    "data-name": "Group 5735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5734",
    "data-name": "Group 5734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5733",
    "data-name": "Group 5733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5732",
    "data-name": "Group 5732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4713",
    "data-name": "Path 4713",
    d: "M390.441,195.419a4.16,4.16,0,0,1,.148-.662c.129-.489.3-1.145.525-1.993l2.151-7.855.085.2-15.841-8.57.346-.06-7.178,8.177-.129.148-.193-.047a44.049,44.049,0,0,0-11.586-1.226l-.22.006-.108-.194c-1.655-2.962-3.446-6.17-5.309-9.5l.456.187-17.277,5.081.313-.446c.212,3.364.445,7.068.684,10.866l.018.276-.239.144a43.811,43.811,0,0,0-9.05,7.284l-.2.211-.28-.08-10.465-2.981.569-.238c-2.715,4.964-5.642,10.317-8.643,15.8l-.11-.635,8.155,7.2.238.21-.076.311a43.949,43.949,0,0,0-1.249,11.533l.009.324-.285.158-9.518,5.287.258-.627c1.6,5.474,3.311,11.341,5.048,17.289l-.563-.4,10.868-.665.335-.02.173.287a43.658,43.658,0,0,0,7.247,9.037l0,0,0,0c.068.248-.149-.552.152.556l0,.01-.006.021-.011.041-.024.082-.047.165-.1.33-.188.658-.377,1.315-.752,2.624-1.494,5.215-.266-.638,15.791,8.667-.675.117,7.214-8.146.219-.247.32.079a43.638,43.638,0,0,0,11.529,1.267l.326-.008.157.284,5.274,9.524-.609-.251,17.294-5.023-.366.52q-.332-5.53-.65-10.867l-.018-.3.258-.155a43.712,43.712,0,0,0,9.07-7.251l.2-.211.279.08,10.455,3.013-.531.222,8.7-15.773.091.522-8.132-7.232-.18-.161.058-.233A43.94,43.94,0,0,0,403.81,226.5l-.005-.222.192-.106,9.537-5.248-.155.378c-1.923-6.707-3.562-12.422-4.965-17.314l.254.179-10.87.592-.109.006-.055-.092a45.724,45.724,0,0,0-5.221-7.111l-1.485-1.6a4.507,4.507,0,0,1-.487-.537,5.632,5.632,0,0,1,.553.472c.351.331.882.833,1.554,1.544a42.709,42.709,0,0,1,5.392,7.051l-.164-.086,10.862-.733.2-.013.057.192c1.446,4.88,3.134,10.579,5.116,17.269l.074.251-.23.128-9.5,5.313.187-.328a44.512,44.512,0,0,1-1.251,11.778l-.122-.393,8.167,7.192.254.224-.163.3c-2.729,5-5.6,10.247-8.632,15.808l-.177.322-.355-.1-10.465-2.977.479-.131a44.584,44.584,0,0,1-9.252,7.441l.24-.455.675,10.865.026.407-.393.115-17.283,5.057-.4.119-.206-.37q-2.608-4.692-5.289-9.514l.482.275a44.633,44.633,0,0,1-11.816-1.284l.537-.167-7.207,8.153-.29.329-.385-.211-15.8-8.659-.388-.212.122-.426,1.494-5.216.751-2.623.377-1.315.188-.659.1-.329.047-.165.023-.082.012-.041.006-.021,0-.01c.3,1.106.083.3.149.552l0,0,0,0a44.713,44.713,0,0,1-7.43-9.268l.507.266-10.867.661-.44.026-.124-.422L305.4,234.017l-.121-.417.379-.211,9.525-5.274-.276.482a44.916,44.916,0,0,1,1.3-11.811l.162.52-8.14-7.22-.309-.274.2-.361L316.8,193.67l.19-.347.38.109,10.455,3.012-.477.13a44.6,44.6,0,0,1,9.27-7.409l-.22.419c-.224-3.8-.443-7.5-.641-10.868l-.021-.349.334-.1,17.3-5,.3-.088.151.275,5.255,9.536-.327-.188a44.568,44.568,0,0,1,11.76,1.323l-.321.1,7.244-8.12.15-.169.2.109,15.74,8.753.126.07-.041.134c-1,3.355-1.774,5.941-2.311,7.734-.262.85-.464,1.506-.616,2A5.122,5.122,0,0,1,390.441,195.419Z",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5740",
    "data-name": "Group 5740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5738",
    "data-name": "Group 5738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4714",
    "data-name": "Path 4714",
    d: "M432.782,213.5,417.09,151.1l63.847-1.055Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5739",
    "data-name": "Group 5739"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 36.281,
    height: 146.72,
    transform: "matrix(0.604, -0.797, 0.797, 0.604, 439.753, 191.069)",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5894",
    "data-name": "Group 5894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    "data-name": "Path 4715",
    d: "M547,373.024l8.11,18.388s-15.967,14.42-14.8,17.964l36.219-14.445-11.461-29.17Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4716",
    "data-name": "Path 4716",
    d: "M547,373.024l8.11,18.388s-15.967,14.42-14.8,17.964l36.219-14.445-11.461-29.17Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4717",
    "data-name": "Path 4717",
    d: "M576.533,394.931l-1.27-2.895-34.251,14.932s-1.333,1.345-.7,2.408Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4718",
    "data-name": "Path 4718",
    d: "M610.784,399.072l10.152,17.344s-14.22,16.145-12.656,19.533l34.337-18.477L627.908,389.8Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4719",
    "data-name": "Path 4719",
    d: "M610.784,399.072l10.152,17.344s-14.22,16.145-12.656,19.533l34.337-18.477L627.908,389.8Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4720",
    "data-name": "Path 4720",
    d: "M642.617,417.472l-1.591-2.731L608.7,433.478s-1.171,1.487-.419,2.471Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5822",
    "data-name": "Group 5822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5818",
    "data-name": "Group 5818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5753",
    "data-name": "Group 5753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5752",
    "data-name": "Group 5752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5746",
    "data-name": "Group 5746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5745",
    "data-name": "Group 5745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5744",
    "data-name": "Group 5744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5743",
    "data-name": "Group 5743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5742",
    "data-name": "Group 5742"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4721",
    "data-name": "Path 4721",
    d: "M566.477,155.775l-22.257,1.734-.739-12.461s-8.978-.131-10.321-8.9-2.657-29.154-2.657-29.154h0a30.828,30.828,0,0,1,31.218-.457l1.443.819Z",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5751",
    "data-name": "Group 5751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5750",
    "data-name": "Group 5750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5749",
    "data-name": "Group 5749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5748",
    "data-name": "Group 5748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5747",
    "data-name": "Group 5747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4722",
    "data-name": "Path 4722",
    d: "M543.449,144.923a20.626,20.626,0,0,0,10.994-4.865s-1.946,6.9-10.823,7.338Z",
    fill: "#eb996e"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5766",
    "data-name": "Group 5766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5759",
    "data-name": "Group 5759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5757",
    "data-name": "Group 5757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5756",
    "data-name": "Group 5756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5755",
    "data-name": "Group 5755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4723",
    "data-name": "Path 4723",
    d: "M563.361,116.607c.141-.086,5.785-2.634,6.437,3.4s-5.538,5.443-5.568,5.271S563.361,116.607,563.361,116.607Z",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5765",
    "data-name": "Group 5765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5764",
    "data-name": "Group 5764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5763",
    "data-name": "Group 5763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5762",
    "data-name": "Group 5762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5761",
    "data-name": "Group 5761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5760",
    "data-name": "Group 5760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4724",
    "data-name": "Path 4724",
    d: "M565.826,122.792c.024-.022.113.062.3.125a1.06,1.06,0,0,0,.788-.069,2.614,2.614,0,0,0,.95-2.463,3.48,3.48,0,0,0-.456-1.473,1.219,1.219,0,0,0-.878-.721.537.537,0,0,0-.589.355c-.063.177-.011.294-.042.307-.015.017-.141-.087-.119-.341a.676.676,0,0,1,.2-.4.8.8,0,0,1,.565-.216,1.485,1.485,0,0,1,1.2.816,3.587,3.587,0,0,1,.546,1.642,2.743,2.743,0,0,1-1.251,2.771,1.132,1.132,0,0,1-.978-.055C565.853,122.937,565.806,122.806,565.826,122.792Z",
    fill: "#eb996e"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5817",
    "data-name": "Group 5817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5816",
    "data-name": "Group 5816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5805",
    "data-name": "Group 5805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5804",
    "data-name": "Group 5804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5803",
    "data-name": "Group 5803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5778",
    "data-name": "Group 5778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5771",
    "data-name": "Group 5771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5770",
    "data-name": "Group 5770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5769",
    "data-name": "Group 5769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5768",
    "data-name": "Group 5768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5767",
    "data-name": "Group 5767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4725",
    "data-name": "Path 4725",
    d: "M534.293,120.8a1.267,1.267,0,0,0,1.388,1.1,1.212,1.212,0,0,0,1.134-1.313,1.268,1.268,0,0,0-1.387-1.1A1.213,1.213,0,0,0,534.293,120.8Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5777",
    "data-name": "Group 5777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5776",
    "data-name": "Group 5776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5775",
    "data-name": "Group 5775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5774",
    "data-name": "Group 5774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5773",
    "data-name": "Group 5773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5772",
    "data-name": "Group 5772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4726",
    "data-name": "Path 4726",
    d: "M533.9,119.118c.179.141,1.03-.7,2.381-.882,1.346-.205,2.434.35,2.558.164.061-.083-.139-.356-.614-.61a3.476,3.476,0,0,0-2.076-.333,3.34,3.34,0,0,0-1.866.906C533.915,118.74,533.816,119.055,533.9,119.118Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5790",
    "data-name": "Group 5790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5783",
    "data-name": "Group 5783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5782",
    "data-name": "Group 5782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5781",
    "data-name": "Group 5781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5780",
    "data-name": "Group 5780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5779",
    "data-name": "Group 5779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4727",
    "data-name": "Path 4727",
    d: "M547.422,119.279a1.267,1.267,0,0,0,1.387,1.1,1.211,1.211,0,0,0,1.134-1.313,1.267,1.267,0,0,0-1.386-1.1A1.212,1.212,0,0,0,547.422,119.279Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5789",
    "data-name": "Group 5789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5788",
    "data-name": "Group 5788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5787",
    "data-name": "Group 5787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5786",
    "data-name": "Group 5786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5785",
    "data-name": "Group 5785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5784",
    "data-name": "Group 5784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4728",
    "data-name": "Path 4728",
    d: "M547.207,117.5c.179.142,1.031-.7,2.381-.881,1.346-.206,2.434.349,2.558.163.061-.083-.137-.356-.615-.609a3.47,3.47,0,0,0-2.075-.334,3.336,3.336,0,0,0-1.866.906C547.22,117.126,547.121,117.441,547.207,117.5Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5796",
    "data-name": "Group 5796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5795",
    "data-name": "Group 5795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5794",
    "data-name": "Group 5794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5793",
    "data-name": "Group 5793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5792",
    "data-name": "Group 5792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5791",
    "data-name": "Group 5791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4729",
    "data-name": "Path 4729",
    d: "M543.716,128.2a8.98,8.98,0,0,0-2.249-.087c-.349.012-.685-.01-.776-.237a1.762,1.762,0,0,1,.086-1.054q.311-1.32.65-2.769a45.407,45.407,0,0,0,1.324-7.187,45.765,45.765,0,0,0-1.9,7.064c-.211.97-.414,1.894-.6,2.778a2.02,2.02,0,0,0,.011,1.378.875.875,0,0,0,.638.424,2.323,2.323,0,0,0,.6,0A8.871,8.871,0,0,0,543.716,128.2Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5802",
    "data-name": "Group 5802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5801",
    "data-name": "Group 5801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5800",
    "data-name": "Group 5800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5799",
    "data-name": "Group 5799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5798",
    "data-name": "Group 5798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5797",
    "data-name": "Group 5797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4730",
    "data-name": "Path 4730",
    d: "M547.82,128.579c-.222.018-.019,1.484-1.126,2.7s-2.691,1.275-2.673,1.481c-.008.1.388.236,1.049.161a3.682,3.682,0,0,0,2.243-1.154,3.2,3.2,0,0,0,.85-2.25C548.133,128.9,547.919,128.556,547.82,128.579Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5810",
    "data-name": "Group 5810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5809",
    "data-name": "Group 5809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5808",
    "data-name": "Group 5808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5807",
    "data-name": "Group 5807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5806",
    "data-name": "Group 5806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4731",
    "data-name": "Path 4731",
    d: "M546.115,112.263c.184.348,1.508-.016,3.118-.047,1.61-.065,2.953.22,3.116-.139.072-.171-.2-.485-.765-.767a5.418,5.418,0,0,0-4.75.141C546.285,111.767,546.033,112.1,546.115,112.263Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5815",
    "data-name": "Group 5815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5814",
    "data-name": "Group 5814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5813",
    "data-name": "Group 5813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5812",
    "data-name": "Group 5812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5811",
    "data-name": "Group 5811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4732",
    "data-name": "Path 4732",
    d: "M533.849,115.141c.281.273,1.166-.176,2.282-.348,1.11-.211,2.094-.084,2.267-.435.074-.17-.118-.456-.573-.688a3.341,3.341,0,0,0-3.665.632C533.809,114.672,533.724,115.006,533.849,115.141Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5821",
    "data-name": "Group 5821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5820",
    "data-name": "Group 5820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5819",
    "data-name": "Group 5819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4733",
    "data-name": "Path 4733",
    d: "M525.443,102.05a3.274,3.274,0,0,1,.79-3.065,2.324,2.324,0,0,1,3.012-.2,2.71,2.71,0,0,1,1.849-3.58c1.42-.292,2.794.618,4.232.8a6.586,6.586,0,0,0,4.035-1.05c1.226-.706,2.339-1.6,3.588-2.265a11.341,11.341,0,0,1,15.294,4.575,5.037,5.037,0,0,1,5.571,1.259,8.261,8.261,0,0,1,2.063,5.587,18.457,18.457,0,0,1-.45,4.083c.016.113.043.222.057.336.588,4.843.839,10.592-1.217,10.913-3.584.561-3.68-6.327-3.68-6.327-4.647-1.083-3.934-7.919-5.177-8.765s-3.876-2.851-12.441,3.163a18.046,18.046,0,0,1-10.784,2.724c-.078-.005-.157-.006-.236-.014l-.054,0c-.03,0-.052-.015-.081-.02a8.357,8.357,0,0,1-2.508-.671,4.724,4.724,0,0,1-2.256-1.894,2.588,2.588,0,0,1,.117-2.821A5.686,5.686,0,0,1,525.443,102.05Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5823",
    "data-name": "Group 5823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4734",
    "data-name": "Path 4734",
    d: "M543.449,152.684l.993,34.873,21.7-46.711-.543-4.324Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5836",
    "data-name": "Group 5836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5824",
    "data-name": "Group 5824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4735",
    "data-name": "Path 4735",
    d: "M557.844,256.933c-.795.26-45.971,45.948-44.956,54.155s33.174,68.984,33.174,68.984l22.944-11.313-21.523-53.283.282-3.305,26.3-21.555-1.4-34.664Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5825",
    "data-name": "Group 5825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4736",
    "data-name": "Path 4736",
    d: "M567.585,265.936c.525.8,8.348,72.574,10.445,76.289s33.52,64.992,33.52,64.992l23.33-9.4L606.4,330.469l3.246-63.74-1.758-18-35.223,7.221Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5827",
    "data-name": "Group 5827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5826",
    "data-name": "Group 5826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4737",
    "data-name": "Path 4737",
    d: "M577.621,340.962a3.989,3.989,0,0,1-.153-.719c-.085-.521-.2-1.21-.339-2.072-.282-1.857-.675-4.452-1.157-7.636l-3.627-25.216c-1.357-9.835-2.585-18.736-3.483-25.242-.416-3.193-.755-5.795-1-7.657q-.153-1.3-.246-2.085a3.9,3.9,0,0,1-.052-.732,3.987,3.987,0,0,1,.152.717c.085.522.2,1.211.339,2.072.281,1.857.675,4.452,1.157,7.635.935,6.5,2.214,15.395,3.628,25.222,1.356,9.832,2.584,18.732,3.482,25.238.416,3.193.755,5.8,1,7.657.1.868.185,1.561.247,2.086A4.114,4.114,0,0,1,577.621,340.962Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5829",
    "data-name": "Group 5829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5828",
    "data-name": "Group 5828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4738",
    "data-name": "Path 4738",
    d: "M605.806,328.41a68.112,68.112,0,0,1-3.2,11.239,68.367,68.367,0,0,1,3.2-11.239Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5831",
    "data-name": "Group 5831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5830",
    "data-name": "Group 5830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    d: "M609.335,344.667a6.551,6.551,0,0,1-1.273-1.771,17.447,17.447,0,0,1-2.173-10.191,6.5,6.5,0,0,1,.441-2.136,22.779,22.779,0,0,0,3.005,14.1Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5833",
    "data-name": "Group 5833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5832",
    "data-name": "Group 5832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    d: "M539.958,307.745a12.3,12.3,0,0,1,6.454,5.886c-.126.084-1.239-1.549-3.025-3.164C541.615,308.837,539.887,307.879,539.958,307.745Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5835",
    "data-name": "Group 5835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5834",
    "data-name": "Group 5834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    d: "M543.5,305.625a10,10,0,0,1,3.485,5.643,30.114,30.114,0,0,1-1.688-2.856A29.837,29.837,0,0,1,543.5,305.625Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5866",
    "data-name": "Group 5866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5838",
    "data-name": "Group 5838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5837",
    "data-name": "Group 5837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4742",
    "data-name": "Path 4742",
    d: "M546.619,200.914l5.775,28.651,4.7,39.983s19.376-2.706,27.634-5.32c9.578-3.032,30.419-5.614,30.419-5.614l-3.513,3.476c7.457-2.088,12.205-9.2,12.205-9.2-12.853-11.92-23.816-36.441-23.816-36.441l-9.773-48.523s-1.484-6.845-2.379-9.889-15.735-12.863-17.792-14.1l-1.293-.611-.411-3.889-1.529-.915-16.06,14.59a17.4,17.4,0,0,0-5.589,10.9,125.863,125.863,0,0,0-.7,18.253C544.688,187.945,546.619,200.914,546.619,200.914Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5848",
    "data-name": "Group 5848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5839",
    "data-name": "Group 5839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4743",
    "data-name": "Path 4743",
    d: "M557.644,151.281s-8.485,4.549-9.956,8.409,2.9,46.184,2.9,46.184l-30.469.572-.095,18.155s48.395,3.824,50.279,1.208c2.546-3.538,5.505-36.61,5.505-36.61l1.1-23.795S574.1,147.258,557.644,151.281Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5841",
    "data-name": "Group 5841",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5840",
    "data-name": "Group 5840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4744",
    "data-name": "Path 4744",
    d: "M552.394,229.565a29.144,29.144,0,0,0,12.2,1.14c4.292-.4,8.658-2.747,10.281-6.74,1.242-3.058.724-6.5.912-9.8.164-2.863.873-5.662,1.3-8.5s-1.037-8.045-1.972-10.755c0,0-1.087,19.647-4.16,27.9a6.755,6.755,0,0,1-1.884,3.012c-1.087.875-2.594.952-3.982,1.1-3.888.406-13.266-.268-13.266-.268"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5843",
    "data-name": "Group 5843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5842",
    "data-name": "Group 5842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4745",
    "data-name": "Path 4745",
    d: "M576.859,167.975a2.673,2.673,0,0,1,0,.432c-.012.307-.028.726-.048,1.264-.055,1.136-.134,2.769-.235,4.861-.111,2.118-.246,4.7-.4,7.689-.184,3-.282,6.415-.65,10.177-.328,3.764-.722,7.884-1.2,12.3-.49,4.416-1.014,9.136-1.854,14.073a30.666,30.666,0,0,1-.837,3.732,7.284,7.284,0,0,1-2.2,3.291,5.563,5.563,0,0,1-3.791,1.354c-1.344.03-2.69,0-4.051-.021-5.439-.134-11.061-.413-16.817-.725-8.648-.478-16.983-1.017-24.772-1.564l-.224-.016V224.6c.039-6.448.076-12.523.109-18.126l0-.209.208-.005,29.409-.632,8.227-.143,2.166-.021c.49,0,.743.016.743.016s-.252.028-.741.051l-2.165.086-8.224.261-29.4.812.209-.214c-.018,5.6-.038,11.678-.06,18.126l-.222-.24c7.787.532,16.121,1.063,24.766,1.541,5.753.312,11.372.594,16.8.735,1.355.018,2.7.054,4.025.026a5.08,5.08,0,0,0,3.5-1.238,6.8,6.8,0,0,0,2.057-3.075,30.447,30.447,0,0,0,.826-3.66c.85-4.909,1.389-9.627,1.9-14.036.49-4.413.9-8.529,1.254-12.289.39-3.757.514-7.173.724-10.165.189-2.988.353-5.565.487-7.682.142-2.088.252-3.719.329-4.853.041-.537.074-.955.1-1.262A2.915,2.915,0,0,1,576.859,167.975Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5845",
    "data-name": "Group 5845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5844",
    "data-name": "Group 5844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    d: "M526.009,224.334a77.425,77.425,0,0,1-.2-8.8,77.73,77.73,0,0,1,.3-8.8,77.135,77.135,0,0,1,.205,8.8A77.769,77.769,0,0,1,526.009,224.334Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5847",
    "data-name": "Group 5847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5846",
    "data-name": "Group 5846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4747",
    "data-name": "Path 4747",
    d: "M522.778,209.486c-.058-.033.246-.372.825-.18a.937.937,0,0,1,.617.806,1.105,1.105,0,0,1-.619,1.088,1.134,1.134,0,0,1-1.225-.226,1.025,1.025,0,0,1-.3-.959c.137-.575.538-.7.551-.639.049.057-.19.269-.2.682a.693.693,0,0,0,.252.571.716.716,0,0,0,.711.114.686.686,0,0,0,.365-.6.588.588,0,0,0-.3-.51C523.1,209.419,522.809,209.551,522.778,209.486Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5849",
    "data-name": "Group 5849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4748",
    "data-name": "Path 4748",
    d: "M590.385,172.08s15.851,20.725,17.782,26.374.439,13.757-2.789,17.634-5.832,2.3-5.832,2.3Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5851",
    "data-name": "Group 5851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5850",
    "data-name": "Group 5850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4749",
    "data-name": "Path 4749",
    d: "M598.979,216.726a33.22,33.22,0,0,1-8.03,1.378,33.243,33.243,0,0,1,8.03-1.378Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5853",
    "data-name": "Group 5853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5852",
    "data-name": "Group 5852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4750",
    "data-name": "Path 4750",
    d: "M602.026,232.007a5.336,5.336,0,0,1,.43,1.094c.241.714.6,1.743,1.075,3a89.142,89.142,0,0,0,4.258,9.6,101.088,101.088,0,0,0,5.325,9.063c.74,1.125,1.351,2.029,1.778,2.65a5.376,5.376,0,0,1,.619,1,5.2,5.2,0,0,1-.776-.883c-.477-.587-1.134-1.462-1.914-2.566a77.756,77.756,0,0,1-5.478-9.033,70.637,70.637,0,0,1-4.146-9.716c-.43-1.282-.744-2.331-.928-3.065A5.313,5.313,0,0,1,602.026,232.007Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5855",
    "data-name": "Group 5855",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5854",
    "data-name": "Group 5854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4751",
    "data-name": "Path 4751",
    d: "M603.1,234.463c2.512,4.477,5.094,9.041,8.921,12.463a23.069,23.069,0,0,1,3.893,3.771c1.03,1.491,1.475,3.576.5,5.1a1.6,1.6,0,0,1-1.58.854,2.026,2.026,0,0,1-1.034-.839,61.734,61.734,0,0,1-10.525-20.666"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5857",
    "data-name": "Group 5857",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5856",
    "data-name": "Group 5856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4752",
    "data-name": "Path 4752",
    d: "M601.01,218.313c2.171-1.559,2.931-4.526,2.609-7.179a26.584,26.584,0,0,0-2.633-7.537,124.091,124.091,0,0,1-7.72-22.643l-1.549-5.749,7.841,41.02Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5859",
    "data-name": "Group 5859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5858",
    "data-name": "Group 5858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    d: "M561.77,149.439a35.076,35.076,0,0,1,2.954-2.951,35.182,35.182,0,0,1,2.951-2.955,17.534,17.534,0,0,1-5.9,5.906Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5861",
    "data-name": "Group 5861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5860",
    "data-name": "Group 5860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4754",
    "data-name": "Path 4754",
    d: "M560.168,152.951c.025.084-.915.367-2.318,1.061a18.425,18.425,0,0,0-8.414,8.514c-.677,1.411-.948,2.354-1.033,2.33-.034-.009.007-.251.109-.685a11.413,11.413,0,0,1,.6-1.79,16.551,16.551,0,0,1,8.589-8.691,11.313,11.313,0,0,1,1.782-.621A1.876,1.876,0,0,1,560.168,152.951Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5863",
    "data-name": "Group 5863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5862",
    "data-name": "Group 5862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M602.739,222.435a1.687,1.687,0,0,1-.249-.4l-.635-1.189c-.567-1.109-1.336-2.613-2.281-4.463l-.009-.017-.005-.024c-.991-4.542-2.394-11.166-3.918-18.534-1.408-6.943-2.681-13.226-3.621-17.861l-1.04-5.424c-.1-.6-.19-1.086-.258-1.48a.264.264,0,1,1,.1-.021l.35,1.461c.3,1.344.7,3.169,1.2,5.392.977,4.627,2.3,10.9,3.764,17.832,1.525,7.367,2.866,14,3.759,18.567l-.014-.041c.888,1.878,1.61,3.406,2.143,4.531l.555,1.229A1.756,1.756,0,0,1,602.739,222.435Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5865",
    "data-name": "Group 5865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5864",
    "data-name": "Group 5864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4756",
    "data-name": "Path 4756",
    d: "M550.065,205.858a8.923,8.923,0,0,1-.232-1.5c-.115-1.06-.265-2.444-.447-4.113-.355-3.474-.812-8.278-1.285-13.587s-.875-10.119-1.14-13.6c-.117-1.674-.213-3.062-.288-4.126a8.935,8.935,0,0,1-.037-1.518,8.685,8.685,0,0,1,.232,1.5c.115,1.06.266,2.445.447,4.113.356,3.475.812,8.278,1.286,13.587s.874,10.115,1.139,13.6c.117,1.674.214,3.063.288,4.127A8.7,8.7,0,0,1,550.065,205.858Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5884",
    "data-name": "Group 5884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5869",
    "data-name": "Group 5869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5867",
    "data-name": "Group 5867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4757",
    "data-name": "Path 4757",
    d: "M520.505,208.57s-6.571-4.985-8.174-5.286c-1.228-.23-8.562-.108-11.935-.038a2.414,2.414,0,0,0-2.42,2.343,1.28,1.28,0,0,0,.023.238,2.2,2.2,0,0,0,1.6,1.667,2.557,2.557,0,0,0-1.776,2.4c-.028,1.9,2.277,2.3,2.277,2.3a3.419,3.419,0,0,0-.329.293,2.272,2.272,0,0,0,1.115,3.813l1.04.236a2.251,2.251,0,0,0-1.387,1.892c.038,2.507,5.675,2.987,5.675,2.987s13.931,2.205,14.232,2.1S520.505,208.57,520.505,208.57Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5868",
    "data-name": "Group 5868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M501.692,200.282c.062.826.256,2.584,1.661,3.381l7.763-.3s-5.781-1.995-6.6-2.981a6.68,6.68,0,0,0-1.108-1.084A1.1,1.1,0,0,0,501.692,200.282Z",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5871",
    "data-name": "Group 5871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5870",
    "data-name": "Group 5870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M507.464,203.283a11.4,11.4,0,0,1-3.545.251,14.384,14.384,0,0,1-3.537-.251,11.4,11.4,0,0,1,3.545-.251A14.39,14.39,0,0,1,507.464,203.283Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5873",
    "data-name": "Group 5873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5872",
    "data-name": "Group 5872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M505.72,207.617a11.246,11.246,0,0,1-6.091-.217,57.691,57.691,0,0,1,6.091.217Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5875",
    "data-name": "Group 5875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5874",
    "data-name": "Group 5874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4761",
    "data-name": "Path 4761",
    d: "M509.67,207.064c.115.071-.034.493-.472.776s-.885.248-.9.113.289-.308.63-.534S509.553,206.984,509.67,207.064Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5877",
    "data-name": "Group 5877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5876",
    "data-name": "Group 5876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4762",
    "data-name": "Path 4762",
    d: "M506.575,212.535a22.365,22.365,0,0,1-6.674-.219,22.365,22.365,0,0,1,6.674.219Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5879",
    "data-name": "Group 5879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5878",
    "data-name": "Group 5878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4763",
    "data-name": "Path 4763",
    d: "M511.011,210.46c.062-.018.183.139.22.444a1.6,1.6,0,0,1-1.358,1.727c-.306.036-.486-.045-.483-.109,0-.137.668-.224,1.112-.794S510.877,210.489,511.011,210.46Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5881",
    "data-name": "Group 5881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5880",
    "data-name": "Group 5880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M507.747,217.351a18.151,18.151,0,0,1-5.975-.739,18.222,18.222,0,0,1,5.975.739Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5883",
    "data-name": "Group 5883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5882",
    "data-name": "Group 5882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4765",
    "data-name": "Path 4765",
    d: "M512.079,214.9c.064-.009.16.161.151.462a1.871,1.871,0,0,1-.416,1.054c-.568.688-1.206.937-1.277.844-.1-.119.412-.575.88-1.151S511.949,214.926,512.079,214.9Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5885",
    "data-name": "Group 5885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4766",
    "data-name": "Path 4766",
    d: "M609,262.509a8.874,8.874,0,0,0,6.732-4.241c.159-.268.3-.634.088-.867a.769.769,0,0,0-.587-.177,18.231,18.231,0,0,0-6.379,1.094.869.869,0,0,0-.572.428.879.879,0,0,0,.027.526l.819,3.154",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5887",
    "data-name": "Group 5887",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5886",
    "data-name": "Group 5886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4767",
    "data-name": "Path 4767",
    d: "M609,262.509a8.874,8.874,0,0,0,6.732-4.241c.159-.268.3-.634.088-.867a.769.769,0,0,0-.587-.177,18.231,18.231,0,0,0-6.379,1.094.869.869,0,0,0-.572.428.879.879,0,0,0,.027.526l.819,3.154"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5893",
    "data-name": "Group 5893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5888",
    "data-name": "Group 5888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    d: "M543.449,152.684s-3.2,10.728-2.315,10.118,2.79-2.3,2.79-2.3Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5889",
    "data-name": "Group 5889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    d: "M543.633,157.63l-1.747,4.177a5.691,5.691,0,0,0-.339,1.349c-.144,1.17-.311,3.315.386,3.464a2.347,2.347,0,0,0,1.868-.772Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5892",
    "data-name": "Group 5892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5890",
    "data-name": "Group 5890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M597.834,158.289s-17.1-6.67-26.563-.78S560.08,172.8,554.443,172.8c-10.994,0-10.642-7.758-10.642-7.758l-2.337.708c-.045,1.587-2.548,12.984,9.038,14.4s16.455-14.382,26.878-14.4a34.6,34.6,0,0,1,18.335,5.637l7.488-4.736Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5891",
    "data-name": "Group 5891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4771",
    "data-name": "Path 4771",
    d: "M553.966,179.956a16.064,16.064,0,0,0,6.595-7.566c2.656-6.128,8.357-13.124,13.118-14.881s15.775-2.985,23.382,1.973l4.873,6.582-6.326,4.1a58.742,58.742,0,0,0-11.147-4.463c-7.862-2.195-12.64.284-17.211,4.61-.284.27-.545.536-.773.793a51.842,51.842,0,0,1-7.237,6.408C557.005,179.109,554.984,179.974,553.966,179.956Z",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5902",
    "data-name": "Group 5902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5895",
    "data-name": "Group 5895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4772",
    "data-name": "Path 4772",
    d: "M199.973,86.875c-10.14,1.562-17.573-6.955-19.944-14.539-2.188-7-3.228-14.283-6.3-20.941-4.3-9.306-15.677-13.606-25.891-12.746s-20.505,5.978-29.542,10.815l2.493,56.017s19.679-20.955,29.134-21.337c15.778-.637,14.918,25.3,30.239,29.126,0,0,21.478,5.823,36-12.933,9.215-11.9,10.032-26.364,10.032-26.364S219.131,83.924,199.973,86.875Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5897",
    "data-name": "Group 5897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5896",
    "data-name": "Group 5896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4773",
    "data-name": "Path 4773",
    d: "M117.879,40.17c.139-.006,2.9,59.479,6.163,132.845,3.266,73.393,5.8,132.875,5.662,132.881s-2.9-59.466-6.163-132.858C120.276,99.671,117.741,40.177,117.879,40.17Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5899",
    "data-name": "Group 5899",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5898",
    "data-name": "Group 5898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    d: "M172.04,68.461A68.164,68.164,0,0,0,179.5,85.275c2.92,4.573,7.35,8.423,12.662,9.531a12.289,12.289,0,0,1,2.842.738,2.748,2.748,0,0,1,1.692,2.228c.041,1.467-1.476,2.427-2.792,3.076a23,23,0,0,1-5.829,2.24c-2.052.384-3.661.6-5.07-.943a29.453,29.453,0,0,1-3.667-4.394c-4.629-7.887-6.919-19.169-7.3-28.094"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5901",
    "data-name": "Group 5901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5900",
    "data-name": "Group 5900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4775",
    "data-name": "Path 4775",
    d: "M185.752,104.433a2.056,2.056,0,0,1-.456-.26c-.289-.186-.7-.481-1.211-.89a20.844,20.844,0,0,1-3.74-4.063,31.173,31.173,0,0,1-3.744-7.283,80.189,80.189,0,0,1-2.773-9.625,107.477,107.477,0,0,1-2.584-17.987c-.129-2.324-.151-4.207-.149-5.507.013-.6.024-1.1.033-1.5a2.017,2.017,0,0,1,.047-.522,2.106,2.106,0,0,1,.054.521c.016.4.036.892.061,1.495.058,1.3.134,3.173.308,5.486a120.231,120.231,0,0,0,2.718,17.9,85.88,85.88,0,0,0,2.718,9.578,32.13,32.13,0,0,0,3.6,7.24,22.741,22.741,0,0,0,3.576,4.118C185.181,103.991,185.777,104.4,185.752,104.433Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Stairs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5903",
    "data-name": "Group 5903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4776",
    "data-name": "Path 4776",
    d: "M56.736,317.722l133.972,21.932V317.722Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5904",
    "data-name": "Group 5904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M212.824,367.267,346.795,389.2V367.267Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5905",
    "data-name": "Group 5905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M367.835,414.662l133.971,21.932V414.662Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5908",
    "data-name": "Group 5908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5906",
    "data-name": "Group 5906"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 133.971,
    height: 16.427,
    transform: "translate(56.736 301.295)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5907",
    "data-name": "Group 5907",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 41.806,
    height: 16.427,
    transform: "translate(148.902 301.295)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5911",
    "data-name": "Group 5911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5909",
    "data-name": "Group 5909"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 133.971,
    height: 16.427,
    transform: "translate(212.824 350.84)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5910",
    "data-name": "Group 5910",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 41.806,
    height: 16.427,
    transform: "translate(304.989 350.84)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5914",
    "data-name": "Group 5914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5912",
    "data-name": "Group 5912"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 133.971,
    height: 16.427,
    transform: "translate(367.835 398.234)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5913",
    "data-name": "Group 5913",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 41.806,
    height: 16.427,
    transform: "translate(460.001 398.234)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5917",
    "data-name": "Group 5917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5915",
    "data-name": "Group 5915"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 133.971,
    height: 16.427,
    transform: "translate(522.847 435.949)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5916",
    "data-name": "Group 5916",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 41.806,
    height: 16.427,
    transform: "translate(615.013 435.949)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5919",
    "data-name": "Group 5919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5918",
    "data-name": "Group 5918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    d: "M574.256,376.157a3.643,3.643,0,1,0,3.643-3.644A3.643,3.643,0,0,0,574.256,376.157Z",
    fill: "#ebebeb"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.a2578c8a2c0987c72b81e6212817c1c1.svg";
export { ForwardRef as ReactComponent };